export default {
  en: {
    none: 'None',
    empty: 'Nothing to show yet.',
  },
};
